import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                黑料聚合网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3">
              <a href={`mailto:${siteInfo.contactInfo.email}`} className="w-9 h-9 rounded-lg bg-background-200/70 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">分类浏览</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['51黑料', '91黑料', '17黑料', '718黑料', '吃瓜', '爆料', '热点'].map((tag) => (
                <span
                  key={tag}
                  className="text-xs text-foreground-600 bg-background-200/70 px-2.5 py-1 rounded-full"
                >
                  #{tag}
                </span>
              ))}
            </div>
            <div className="mt-4">
              <p className="text-xs text-foreground-500">
                联系邮箱：{siteInfo.contactInfo.email}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料聚合网 - 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站为内容聚合平台，所有内容版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}